import { OnOffSetting } from '../../../components/OnOffSetting';
import { useFormContext } from '../../../contexts/formContext';

const path = 'assetSimplification.topologySettings.preserveTopology';

export function PreserveTopology() {
  const form = useFormContext();
  return (
    <OnOffSetting
      title='Preserve Topology'
      description='Turn on to better preserve original mesh topology (like holes) during decimation. Not recommended when using a very low number of polygons.'
      onChanged={(option) => form.setFieldValue(path, option)}
      initialOption={form.values.assetSimplification?.topologySettings.preserveTopology ?? false}
    />
  );
}
